import { render, staticRenderFns } from "./EditPersonalResourceDialog.vue?vue&type=template&id=755ba50c&scoped=true"
import script from "./EditPersonalResourceDialog.vue?vue&type=script&lang=js"
export * from "./EditPersonalResourceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPersonalResourceDialog.vue?vue&type=style&index=0&id=755ba50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ba50c",
  null
  
)

export default component.exports